module.exports = __webpack_public_path__ + "static/app-d7311dfc45378dd323ffa007f8789647.jpg";